import IndexPage from '../pages/IndexPage'

export default {
  '/': IndexPage
}
